<template>
  <div class='container'>
    <div class='zero-main-top flex align-items space-between fixed fixed-height'>
      <div class='zert-top-left flex align-items'>
        <div class='zero-top-img'>
          <img v-lazy="iconImg" alt="" />
        </div>
        <div class='zero-top-text'>
          <div>当前可用免单卡</div>
          <div class='count'><span class='fs-34'>{{cardCount}}</span> 张</div>
        </div>
      </div>
    </div>
    <div class='fixed-height'></div>
    <!-- 详情列表 -->
    <div
      class='free-card-list'
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollDisabled"
      infinite-scroll-immediate-check="false">
        <div class='free-card-item flex' v-for="(item, index) in dataList" :key="index">
          <div class='card-item-left flex'>
            <div :class="['icon-box', item.OperateType ? 'add' : 'reduce']">
              <div :class="['iconfont', item.OperateType ? 'icon-xin': 'icon-icon-test1']"></div>
            </div>
            <div>
              <div class='card-desc'>{{item.Remark}}</div>
              <div class='card-time'>{{item.CreateTime | formatTime}}</div>
            </div>
          </div>
          <div class='card-item-right flex'>
            <div class='card-item-img'>
              <img :src="iconImg" alt="" />
            </div>
            <div>{{item.OperateType ? '+' : ''}}{{item.Qty}}</div>
          </div>
        </div>
    </div>
    <segement-Line
      v-if="!haveMore"
      :line-text="dataList.length > 0 ? '没有更多明细了' : '暂无使用明细'">
    </segement-Line>
    <segement-Line
      v-else
      :is-load="true">
    </segement-Line>
  </div>
</template>

<script>
import SegementLine from '@/components/puppetComponent/SegementLine'
import moment from 'moment'
import { Indicator } from 'mint-ui'
import { GetFreeCardLog } from '@/api/zeroBuy'
import { IMG_BASE_URL } from '@/config'

export default {
  data () {
    return {
      evaluateID: null,
      iconImg: IMG_BASE_URL + '/upaiyun/Sys/20181217/4737334625133973679.png',
      haveMore: true,
      scrollDisabled: false,
      dataList: [],
      cardCount: 0,
      currentPage: 1,
      page: 1,
      pageCount: 1
    }
  },
  components: {
    SegementLine
  },
  mounted () {
    this.evaluateID = this.$route.query.id ? this.$route.query.id : null
    this.fetchData()
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      let params = {
        EvaluateID: this.evaluateID,
        page: this.currentPage
      }
      GetFreeCardLog(params).then(res => {
        Indicator.close()
        this.scrollDisabled = false
        this.dataList = [...this.dataList, ...res.DataList]
        this.cardCount = res.FreeCardQty
        this.page = res.PaginationViewModel.Page
        this.pageCount = res.PaginationViewModel.PageCount
        if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
          this.haveMore = false
        }
      }).catch(() => {
        Indicator.close()
        this.haveMore = false
      })
    },
    // 加载更多
    loadMore () {
      let { page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage += 1
      this.haveMore = true
      this.fetchData()
    }
  },
  filters: {
    formatTime (val) {
      if (val) {
        return moment(val).format('YYYY年MM月DD日 HH:mm')
      } else {
        return '----:--'
      }
    }
  }
}
</script>

<style scoped>
  @import '../zeroBuy.css';
  /* 详情列表 */
  .free-card-list{
    background: #fff;
    margin-top: 15px;
  }
  .free-card-item{
    height: 70px;
    padding: 20px 0;
    margin: 0 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #f5f5f5;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }
  .free-card-item:last-child{
    border-bottom: none;
  }
  .card-item-left{
    align-items: center;
    justify-content: space-between;
  }
  .card-item-left .icon-box{
    width: 45px;
    height: 45px;
    line-height: 45px;
    margin-right: 10px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
  }
  .card-item-left .icon-box .iconfont{
    font-size: 20px;
  }
  .card-item-left .add{
    background: #FFC181;
  }
  .card-item-left .reduce{
    background: #BEE2FD;
  }
  .card-item-left .card-desc{
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
  }
  .card-item-left .card-time{
    color: #999;
    font-size: 13px;
    margin-top: 5px;
  }
  .card-item-right{
    margin-right: 10px;
    align-items: center;
  }
  .card-item-right div:last-child{
    min-width: 35px;
    text-align: right;
  }
  .card-item-img{
    width: 35px;
    /* height: 30px; */
  }
  .card-item-img img{
    width: 100%;
    height: 100%;
  }
</style>
